import { useState } from "react";
import { PrimaryButton } from "./Button";
import { LoadingDots } from "./LoadingDots";
import { SheetContainer } from "./SheetContainer";
import { strings } from "../strings";

// Coffee icon SVG
function CoffeeIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M10 2v2" />
      <path d="M14 2v2" />
      <path d="M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1" />
      <path d="M6 2v2" />
    </svg>
  );
}

export interface PausedSheetProps {
  onReconnect: () => Promise<void>;
  isLoading?: boolean;
  className?: string;
}

export function PausedSheet({
  onReconnect,
  isLoading = false,
  className,
}: PausedSheetProps) {
  const [isReconnecting, setIsReconnecting] = useState(false);

  const handleReconnect = async () => {
    setIsReconnecting(true);
    try {
      await onReconnect();
    } finally {
      setIsReconnecting(false);
    }
  };

  const loading = isLoading || isReconnecting;

  return (
    <SheetContainer className={`gap-6 ${className || ""}`}>
      {/* Header */}
      <div>
        <div className="flex items-center gap-3 mb-4">
          <CoffeeIcon className="w-6 h-6 text-primary" />
          <h2 className="text-2xl font-semibold text-foreground">
            {strings.pausedSheet.title}
          </h2>
        </div>

        <div className="text-muted-foreground text-left flex flex-col gap-3">
          <p className="text-base">{strings.pausedSheet.description1}</p>
          <p className="text-base">{strings.pausedSheet.description2}</p>
        </div>
      </div>

      {/* Reconnect button */}
      <div>
        <PrimaryButton
          onClick={handleReconnect}
          disabled={loading}
          className="w-full"
        >
          {loading ? (
            <span className="flex items-center gap-2">
              <LoadingDots size="sm" />
              {strings.pausedSheet.buttonReconnecting}
            </span>
          ) : (
            strings.pausedSheet.buttonReconnect
          )}
        </PrimaryButton>
      </div>
    </SheetContainer>
  );
}
